import axios from 'axios';
import { BASE_URL } from '../../../../../Utlils';

export const submitEditSupplierInfo = async (data) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data._id}/update-supplier-information`,
      data,
    );
    const responseData = response?.data;
    if (responseData.success) {
      return responseData?.data;
    } else {
      throw new Error(responseData?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};

export const submitEditSupplierLocations = async (data) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data._id}/update-supplier-locations`,
      data,
    );
    const responseData = response?.data;
    if (responseData.success) {
      return responseData?.data;
    } else {
      throw new Error(responseData?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};

export const submitUpdateSupplierBusinessIDs = async (data) => {
  'use server';
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data?._id}/update-supplier-business-ids`,
      data,
    );
    const responseData = response?.data;
    if (responseData.success) {
      return responseData?.data;
    } else {
      throw new Error(responseData?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};

export const submitEditSupplierBankAccounts = async (data) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/suppliers/${data._id}/update-supplier-bank-accounts`,
      data,
    );
    const responseData = response.data;
    if (responseData.success) {
      return responseData?.data;
    } else {
      throw new Error(responseData?.message || 'An error occurred');
    }
  } catch (error) {
    console.log('error occurred', error);
    return { error: error || 'An Unknown error occured' };
  }
};
